// This file was auto-generated by Fern from our API Definition.
/**
 * Which model identifiers did the provider return?
 *
 * `unsupported` means the provider offers no model-list endpoint; `failed` means one
 * exists but this attempt did not get an answer. Either way the caller keeps the
 * shipped catalog rather than narrowing the user's model choice.
 */
export const DiscoveryStatus = {
    Fetched: "fetched",
    Unsupported: "unsupported",
    Failed: "failed",
};
